const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        sorter: true,
    },
    {
        title: 'Phone No.',
        dataIndex: 'phoneNo',
    },
    {
        title: 'From',
        dataIndex: 'from',
        sorter: true,
    },
    {
        title: 'To',
        dataIndex: 'to',
        sorter: true,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        sorter: true,
    },
    {
        title: 'Transaction Date',
        dataIndex: 'transactionDate',
        sorter: true,
    },
    {
        title: 'Action By',
        dataIndex: 'actionBy',
    },
    {
        title: 'Action Date',
        dataIndex: 'actionDate',
        sorter: true,
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    }
];

export default columns;